import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { CheckCircle, Loader } from 'lucide-react'
import { paymentService } from 'services/paymentService'
import { OrderProps } from 'hooks/useOrderB2c'

interface PagalevePaymentProps {
  order: OrderProps
  onProcessingChange?: (isProcessing: boolean) => void
}

export const PagalevePayment = ({ order, onProcessingChange }: PagalevePaymentProps) => {
  const history = useHistory()
  const [checkoutUrl, setCheckoutUrl] = useState<string | null>(null)
  const [isProcessing, setIsProcessing] = useState<boolean>(false)
  const [paymentConfirmed, setPaymentConfirmed] = useState<boolean>(false)
  const [redirectCountdown, setRedirectCountdown] = useState<number>(3)
  const pollingIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useEffect(() => {
    onProcessingChange?.(isProcessing)
  }, [isProcessing, onProcessingChange])

  useEffect(() => {
    async function createCheckout() {
      if (!order?.id) return
      setIsProcessing(true)
      try {
        const url = await paymentService.generatePagaleveCheckout(order.id, {
          cep: order?.cep,
          city: order?.city,
          state: order?.state,
          district: order?.district,
          address_number: order?.address_number,
          complement: order?.complement,
        })
        setCheckoutUrl(url)
      } catch (e) {
        setIsProcessing(false)
      }
    }
    createCheckout()
  }, [order?.id])

  useEffect(() => {
    if (checkoutUrl) {
      // Auto-redirect após contagem regressiva curta
      const timer = setInterval(() => setRedirectCountdown((sec) => sec - 1), 1000)
      if (redirectCountdown <= 0) {
        window.open(checkoutUrl, '_blank')
        clearInterval(timer)
      }
      return () => clearInterval(timer)
    }
    return undefined
  }, [checkoutUrl, redirectCountdown])

  // Não faz polling – redireciono ao checkout da Pagaleve e a própria Pagaleve volta para as rotas de sucesso/erro

  if (paymentConfirmed) {
    return (
      <div style={{ padding: 24, textAlign: 'center' }}>
        <CheckCircle size={48} color="#48B791" />
        <h3>Pagamento confirmado!</h3>
        <p>Seu pedido foi processado com sucesso.</p>
        <p>Você será redirecionado para a tela de status em alguns segundos.</p>
      </div>
    )
  }

  return (
    <div style={{ padding: 24, textAlign: 'center' }}>
      <Loader className="mr-2 animate-spin" />
      <h3>PIX Parcelado (Pagaleve)</h3>
      {checkoutUrl ? (
        <>
          <p>Abriremos o checkout em uma nova aba em {redirectCountdown}s.</p>
          <a href={checkoutUrl} target="_blank" rel="noreferrer" style={{ color: '#006DE6', fontWeight: 600 }}>
            Abrir agora
          </a>
        </>
      ) : (
        <p>Gerando checkout...</p>
      )}
      <p>Estamos monitorando o status do pagamento automaticamente.</p>
    </div>
  )
}

